import { setCookie } from '@js/globalFunctions/cookieHandling'
import {resetStoredData} from "@js/parts/search/functions/reset/resetStoredData";

export function resetSearch(){
	resetStoredData();
	let onAreaPage = false;
	let areaTesting;
	if( dataholder.selectedAreaHolder.length === 1 )
	{
		areaTesting = dataholder.selectedAreaHolder[0];

		if(typeof areaTesting != 'undefined' && areaTesting !== 'none'){
			if(window.location.href.indexOf(siteUrl + "/" + areaTesting + "/") !== -1){
				onAreaPage = true;
			}
		}
	}
	$('#frontAdvancedSearch select').each(function(i, el){
		if(onAreaPage && el.name === 'omraader'){

		}else{
			el.selectedIndex = 0;
			$(el).removeClass('highlight');
		}
	});
	$('select.sorting').each(function(i,el){
		el.selectedIndex = 0;
	});

	$('#frontAdvancedSearch input[type=checkbox]:not(input[name=177])').each(function(i, el){
		$(el).prop('checked', false);
	});

	if (!onAreaPage) {
		$('select[name="vejnavn"] option').removeAttr('hidden');
	}

	$('#freetext').val('').removeClass('highlight');
	$('#freeSearchInputField').val('').removeClass('highlight');

	if(onAreaPage){
		searchParameters.clearParameters();
		searchParameters.setParameter('omraader',areaTesting)
	}else{
		searchParameters.clearParameters();
	}

	setCookie('searchOrder','default',2);

}
